// Nama File: HighchartsPie3DComponent.tsx

import React from 'react';
import { Card } from 'react-bootstrap';
// Impor yang Anda temukan sudah benar jika `esModuleInterop` aktif.
import Highcharts from 'highcharts';
import Highcharts3D from 'highcharts/highcharts-3d';
import HighchartsReact from 'highcharts-react-official';

// Inisialisasi modul 3D
Highcharts3D(Highcharts);

// 1. Definisikan interface untuk props yang akan diterima
interface HighchartsPie3DProps {
    title: string;
    data: { name: string; value: number; color?: string | null }[];
}

// 2. Ubah komponen untuk menerima props
const HighchartsPie3DComponent: React.FC<HighchartsPie3DProps> = ({ title, data }) => {

    // 3. Transformasi data dari props ke format yang dibutuhkan Highcharts
    const chartData = data.map(item => ({
        name: item.name,
        y: item.value, // 'value' dari data Anda menjadi 'y'
        color: item.color || undefined, // Gunakan warna jika ada
    }));

    const options: Highcharts.Options = {
        chart: {
            type: 'pie',
            backgroundColor: 'transparent',
            options3d: {
                enabled: true,
                alpha: 45,
            },
        },
        title: {
            // 4. Gunakan 'title' dari props
            text: title,
        },
        plotOptions: {
            pie: {
                innerSize: '60%',
                depth: 45,
                dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}</b>',
                },
            },
        },
        series: [{
            type: 'pie', // Tipe ditambahkan untuk TypeScript
            name: 'Total',
            // 5. Gunakan 'chartData' yang sudah ditransformasi
            data: chartData,
        }],
        credits: {
            enabled: false,
        }
    };

    return (
        <Card className="p-3 bg-white rounded shadow-sm h-100">
            <HighchartsReact highcharts={Highcharts} options={options} />
        </Card>
    );
};

export default HighchartsPie3DComponent;